import type { MouseEvent, ReactNode } from "react";
import { cn } from "@/utilities/tailwind-utils";

export interface ProfileDisplayNameProps {
  children: ReactNode;
  /** Use compact typography (list cards) vs extended (detail-style header). */
  compact: boolean;
  /** When set, the name is interactive (primary + underline on hover) and the click does not bubble. */
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Heading for practice/professional display name; optional button behavior for navigation/actions.
 */
export function ProfileDisplayName({
  children,
  compact,
  onClick
}: ProfileDisplayNameProps) {
  const base = compact
    ? "text-sm font-semibold truncate leading-tight min-w-0"
    : "text-base font-semibold truncate leading-tight min-w-0";

  if (!onClick) {
    return <h3 className={base}>{children}</h3>;
  }

  return (
    <button
      type="button"
      className={cn(
        base,
        "text-left p-0 m-0 bg-transparent border-0 text-primary hover:underline cursor-pointer",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background rounded-sm"
      )}
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      {children}
    </button>
  );
}
